import { Outlet } from 'react-router-dom';
import styles from './ContentContainer.module.scss';

const ContentContainer = () => {
  return (
    <div className={styles.container}>
      <div className={styles.outlet}>
        <Outlet />
      </div>
    </div>
  );
};

export default ContentContainer;
